// extracted by mini-css-extract-plugin
export default {"fields":"jScFUgVqvtCobnN_qrDi","field":"GlDKYn3OIAzBz2JNwbus","tooltipIcon":"fEUWT_uBFGmbZLP1fDE2","tooltip":"fHA_t8iStFbnnCI8LV0a","divider":"Q5xJg5iS5rKxhYtVo7eA"};